<template>
  <div class="home-page-box">
    <!-- 顶部 -->
    <homeHead ref="homeSearch" :pages="notice" @childEvent="handleChildEvent" :isRouterIndex="'1'" :param="titles"></homeHead>

    <div class="home-page-content">
      <!-- 应用服务 -->
      <div class="home-app">
        <div class="home-card">
          <div class="home-card__header">
            <div class="home-card__header__title">
              <img src="./../../../../assets/homeNew/yyfw-icon.png" />
              <span>应用服务</span>
            </div>
          </div>
          <div class="home-card__content border-radius__16  overflow-auto backgroundTr">
            <div class="home-card__content--wrapper ">

              <!-- 应用 -->

              <div class="app-list__content ">
                <div class="app-list__items" v-if="selectDataList.length > 0">
                  <div class="app-list">
                    <div class="app-list__item" v-for="(it, ind) in selectDataList" :key="ind" @click="goData(it)">
                      <img :src="it.logo" alt="">

                      <span> {{ it.name }}</span>
                    </div>
                  </div>
                </div>
                <div class="no-wrap" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 文章 -->
      <div class="home-app">
        <div class="home-card">
          <div class="home-card__header">
            <div class="home-card__header__title">
              <img src="./../../../../assets/homeNew/yyfw-icon.png" />
              <span>通知公告</span>
            </div>
            <div class="home-card__header__more" @click="goNotiList">
              <span>查看全部</span>
              <img src="./../../../../assets/homeNew/arrow-right.png" />
            </div>
          </div>
          <div class="home-card__content border-radius__16  overflow-auto backgroundTr">
            <div class="home-card__content--wrapper ">

              <!-- 应用 -->

              <div class="app-list__content ">
                <div class="article-padding-box" v-if="noticeList.length > 0">
                  <div class="article-list-box hairline-bottom" v-for="(item,index) in noticeList" :key="index" @click="goNotice(item)">
                    <div class="icon"></div>
                    <div class="title">
                      {{item.title}}
                    </div>
                    <div class="time">
                      {{item.releaseTime  | analyseTime('1')}}
                    </div>
                  </div>
                </div>
                <div class="no-wrap" v-else>
                  <img src="./../../../../assets/homes/nodatas.png" class="no-img" alt="">
                  <div class="no-title">
                    暂无数据
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <homeFooter></homeFooter>
  </div>
</template>
<script>
import homeHead from '../../component/homeHead.vue'
import homeFooter from '../../component/homeFooter.vue'

import { analyseTime } from '../../../../components/filter'
import { getArticleListByType, searchFromStore } from '../../../../api/api.p'
import { dateFormat } from '../../../../libs/util'
import homeSearch from '../../component/homeSearch.vue'
import axios from 'axios';

export default {
  props: {},
  data () {
    return {
      allList: [],

      selectDataList: [],
      allDataList: [
        {
          "groupIcon": "",
          "groupName": "测试1",
          "groupType": "G",
          "id": 1,
          "serviceVOList": [
            {
              "feedbackUrl": "string",
              "groupId": 0,
              "homeUrl": "string",
              "id": 1,
              "role": "string",
              "serviceIcon": "",
              "serviceId": "1",
              "serviceName": "测试分类1",
              "slogan": "",
              "sort": 0,
              "status": 0
            }
          ],
          "sort": 0,
          "status": 0
        },
        {
          "groupIcon": "",
          "groupName": "测试2",
          "groupType": "G",
          "id": 2,
          "serviceVOList": [
            {
              "feedbackUrl": "string",
              "groupId": 0,
              "homeUrl": "string",
              "id": 2,
              "role": "string",
              "serviceIcon": "",
              "serviceId": "2",
              "serviceName": "测试分类2",
              "slogan": "",
              "sort": 0,
              "status": 0
            }
          ],
          "sort": 0,
          "status": 0
        },


      ],

      titles: '',
      noticeList: [],
      notice: 'search',
    }
  },
  filters: {

  },
  components: {
    homeHead,
    homeFooter,
    homeSearch,
    // vMiniWeather,
    // vMiniWeatherIcon
  },
  created () {
  },
  mounted () {
    if (this.$route.query.title) {
      this.titles = this.$route.query.title
      console.log(this.titles)
      this.$nextTick(() => {
        this.$refs.homeSearch.init();
        this.getArticleListByTypeFun()
        this.searchFromStore();
      })
    }


  },
  methods: {
    goNotiList () {
      this.$router.push({
        path: '/noticeList',
        query: {

        }
      })
    },
    goData (item) {
      window.open(item.homeUrl)
      // window.location.href = item.homeUrl
    },
    handleChildEvent (data) {
      // console.log(data); // 处理从子组件接收到的数据
      this.titles = data;
      this.pageNum = 1;

      this.getArticleListByTypeFun()
      this.searchFromStore();

      // 可以在这里调用其他方法或执行其他操作
    },
    // 获取我的应用
    async searchFromStore () {
      let params = {
        name: this.titles,
        appType: 0,
        pageNumber: 1,
        numPerPage: 10000
      }
      const res = await searchFromStore(params);
      if (res) {

        if (res.meta.code == 0) {
          this.selectDataList = res.data.records;

        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

    goNotice (item) {
      let ids = JSON.parse(JSON.stringify(item))
      this.$router.push({
        path: '/noticeDetail',
        query: {
          articleId: ids.id,
        }
      })
    },
    async getArticleListByTypeFun () {

      let param = {
        type: '通知公告',
        title: this.titles,
        "pageNumber": 1,
        "numPerPage": 10,
      }
      const res = await getArticleListByType(param);
      if (res) {

        if (res.meta.code == 0) {
          this.noticeList = res.data.records;
          this.zongtiaoshu = JSON.parse(res.data.total);
        } else {
          this.$toast(res.meta.message);
        }

      } else {

        this.$toast('操作失败');
      }

    },

  },
}
</script>

<style lang="less" scoped>
@import './search.less';
</style>


